export enum ProjectType {
  New = 'new',
  Repair = 'repair',
  Replace = 'replace',
  NotSure = 'not_sure',
}

export enum WindowsNumber {
  One = 'one',
  Two = 'two',
  ThreeToFive = 'three_to_five',
  SixToNine = 'six_to_nine',
  TenOrMore = 'ten_or_more',
}
